export const formatTestId = (value: string, prefix: string = ''): string =>
  value ? `${prefix}${value.replace(/(\s|,)+/g, '-').toLowerCase()}` : '';
